'use client';

import { useLayoutEffect, useRef } from 'react';

export function useCachedValue<T>(value: T): React.RefObject<T | null> {
  const cache = useRef(value);
  useLayoutEffect(() => {
    cache.current = value;
  });
  return cache;
}
